import { smoothScrollIntoView } from '@cian/valuation-utils-component';
import { path } from 'ramda';
import * as React from 'react';

import { EScrollingBlocks } from '../../../types/page/scrolling';
import { scrollingContext } from '../context';

export const useScrollToBlock = () => {
  const { refBlocksState } = React.useContext(scrollingContext);

  return React.useCallback(
    (blockId: EScrollingBlocks) => {
      const block = path<HTMLDivElement>([blockId, 'ref', 'current'], refBlocksState);
      if (block) {
        smoothScrollIntoView(block, 32);
      }
    },
    [refBlocksState],
  );
};
